export default __webpack_public_path__ + "static/media/menu.5ae2b36a.svg";